import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { QRCodeSVG } from 'qrcode.react';
import '@/Pages/Mobile/MobilePage.sass';

const QR_SIZE_PX = 200;
const QR_FOREGROUND = '#000000';
const QR_BACKGROUND = '#ffffff';

export type QRCodeDisplayProps = {
  value: string;
  caption: string;
  title: string;
};

export function QRCodeDisplay({
  value,
  caption,
  title,
}: QRCodeDisplayProps): JSX.Element {
  return (
    <Box
      component="section"
      className="mobile-validation-qr"
      data-testid="mobile-validation-qr"
      aria-labelledby="mobile-qr-caption"
    >
      <Box className="mobile-validation-qr__container">
        <QRCodeSVG
          value={value}
          title={title}
          aria-label={title}
          role="img"
          size={QR_SIZE_PX}
          bgColor={QR_BACKGROUND}
          fgColor={QR_FOREGROUND}
          className="mobile-validation-qr__svg"
          data-testid="mobile-validation-qr-svg"
        />
      </Box>

      <Typography
        id="mobile-qr-caption"
        component="p"
        className="mobile-validation-qr__caption"
        data-testid="mobile-validation-qr-caption"
      >
        {caption}
      </Typography>
    </Box>
  );
}
